import { render, staticRenderFns } from "./SharedWithComponent.vue?vue&type=template&id=03c547d9&"
import script from "./SharedWithComponent.vue?vue&type=script&lang=js&"
export * from "./SharedWithComponent.vue?vue&type=script&lang=js&"
import style0 from "./SharedWithComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports